import * as types from "../Reducers/types";

export const setUsername = (username: String) => {
  return { type: types.SET_USERNAME, username };
};

export const setPassword = (password: String) => {
  return { type: types.SET_PASSWORD, password };
};
export const setSession = (loggedin: Boolean) => {
    return { type: types.SET_SESSSION, loggedin };
  };
export const setToken = (token: string) => {
  return { type: types.SET_TOKEN, token };
};